import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AlunoCard } from '../../shared/components/aluno-card/aluno-card';
import { AlunoMatriculaCardComponent } from '../../shared/components/aluno-matricula-card/aluno-matricula-card';
import { MatIconModule } from '@angular/material/icon';
import { MatriculaService } from '../../services/matricula.service';
import { PreMatriculaService } from '../../services/pre-matricula.service';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
  selector: 'app-matriculas',
  imports: [
    CommonModule,
    AlunoCard,
    AlunoMatriculaCardComponent,
    MatIconModule,
    MatProgressSpinnerModule
],
  templateUrl: './matriculas.html',
  styleUrl: './matriculas.scss'
})
export class Matriculas {
  listaMatriculas: any[] = [];
  listaCardsReMatriculas: any[] = [];
  matriculas: any[] = [];
  preMatriculas: any[] = [];
  preMatriculasAux: any[] = [];
  anoLetivoPreMatricula: any;
  alunosProcessoFinalizadoEPagoOuPendente: any[] = [];

  constructor(
    private matriculaService: MatriculaService,
    private preMatriculaService: PreMatriculaService
  ){}

  ngOnInit() {
    this.buscarTodosAlunos();

  }

  ordenaAlunos() {
    this.matriculas = this.matriculas.sort((a, b) => {// 1. Ordena por preMatricula: true vem antes de false
      if ((a.matriculaTipoDescricao === 'Pre-Matricula') !== (b.matriculaTipoDescricao === 'Pre-Matricula')) {
        return a.matriculaTipoDescricao === 'Pre-Matricula' ? -1 : 1;
      }

      // 2. Ordena por periodo (ano letivo): maior ano primeiro
      // const anoA = isNaN(a.anoLetivoDescricao) ? 0 : a.anoLetivoDescricao;
      // const anoB = isNaN(b.anoLetivoDescricao) ? 0 : b.anoLetivoDescricao;
      const anoA = parseInt(a.matricula.anoLetivo.dataInicio.slice(0, 4), 10); // extrai o ano do formato 'YYYY-MM-DD'
      const anoB = parseInt(b.matricula.anoLetivo.dataInicio.slice(0, 4), 10);
      if (anoA !== anoB) {
        return anoB - anoA;
      }

      // 3. Ordena por status: 'Ativo' vem antes de 'Inativo'
      const statusOrder: any = { 'Ativo': 0, 'Inativo': 1 };
      return statusOrder[a.status] - statusOrder[b.status];

    });

  }

  buscarTodosAlunos() {
    this.listaCardsReMatriculas = [];
    let matriculasAux: any[] = [];

    this.matriculaService.buscarMatriculas().subscribe(data => {
      this.listaMatriculas = data.body;
      const alunosIdsUnicos = Array.from(new Set(this.listaMatriculas.map(aluno => aluno.matricula.alunoId)));

        this.preMatriculaService.buscarAlunosPreMatriculas(alunosIdsUnicos).subscribe(preMatriculasData => {
          this.preMatriculas = preMatriculasData.body || [];
          this.preMatriculasAux = [...this.preMatriculas];

          this.preMatriculaService.VerificaAnoLetivoPreMatricula(alunosIdsUnicos).subscribe(verificaAnoLetivoData => {
              this.anoLetivoPreMatricula = verificaAnoLetivoData.body?.preMatriculaAnoLetivo ?? null;
              this.alunosProcessoFinalizadoEPagoOuPendente = verificaAnoLetivoData.body?.preMatriculaAlunos ?? [];

              this.matriculas = this.listaMatriculas.map(matriculaAluno => {

                 // verifica se aluno tem pre matricula
                const mostraPreMatricula = (this.preMatriculas.some((pm: any )=> {
                  return pm.alunoId === matriculaAluno.alunoId}));

                const mostraCardPontilhado = (
                    (matriculaAluno.matricula.anoLetivo.anoLetivoId !== verificaAnoLetivoData.body?.anoLetivoId) &&
                    this.verificaSeAlunoPreMatriculaEmDia(matriculaAluno.alunoId) &&
                    (!this.listaCardsReMatriculas.some((al: any) => al.alunoId === matriculaAluno.alunoId) &&
                    (!this.listaMatriculas.some((m: any) => m.alunoId === matriculaAluno.alunoId && m.matricula.anoLetivo.anoLetivoId === verificaAnoLetivoData.body?.anoLetivoId)) &&
                    (mostraPreMatricula === false))
                  )

                // condicoes para mostrar card pontilhado e estiver em ano letivo de preMatricula
                if((mostraCardPontilhado === true) && (verificaAnoLetivoData.body && verificaAnoLetivoData.body.preMatriculaAnoLetivo !== null)) {
                  if(!this.listaCardsReMatriculas.some(card => card.nomeAluno === matriculaAluno.nomeAluno)) {
                    this.listaCardsReMatriculas.push({
                      nomeAluno: matriculaAluno.nomeAluno,
                      alunoId: matriculaAluno.alunoId,
                      anoLetivoId: verificaAnoLetivoData.body?.anoLetivoId,
                      anoLetivoPreMatricula: verificaAnoLetivoData.body?.preMatriculaAnoLetivo.descricao ?? '',
                    });
                  }
                }


                if (mostraPreMatricula === true) {
                  const index = this.preMatriculas.findIndex((pm: any) => pm.alunoId === matriculaAluno.alunoId);
                  if (index !== -1) {
                    const preMatricula = this.preMatriculas[index];
                    this.preMatriculas.splice(index, 1);
                    matriculasAux.push(preMatricula);

                  }
                }

                return {
                  ...matriculaAluno,
                }
              });
            // }
            this.ordenaAlunos();
            this.matriculas.unshift(...matriculasAux);
            // verifica novamente preMatriculas para mostrar cards pontilhados em casos de erro ou "abandono do processo"
            this.conferePreMatriculas();

          });
        });
    });
  }

  //olhando de vai mostrar card pontilhado pra preMatricula
  conferePreMatriculas() {
    // Verifica se existem pré-matrículas pendentes abandonadas (pendente de pagamento )
    this.preMatriculasAux.forEach(preMatricula => {
      if(preMatricula.preMatriculaStatus === 2 &&
        (preMatricula.contaStatus === "Pendente" || preMatricula.contaStatus === "Erro") &&
        !this.listaCardsReMatriculas.some(card => card.alunoId === preMatricula.alunoId)) {
        this.listaCardsReMatriculas.push({
          nomeAluno: preMatricula.nomeAluno,
          alunoId: preMatricula.alunoId,
          anoLetivoId: this.anoLetivoPreMatricula.anoLetivoId,
          anoLetivoPreMatricula: this.anoLetivoPreMatricula.descricao ?? '',
        });
      }
    });
  }

  verificaSeAlunoPreMatriculaEmDia(alunoId: any) {
    //Pega a lista de processos finalizados pagos e pendentes, se existir
    // e verifica se aquele aluno está na lista
    // se sim não precisa mostrar o card pontilhado (retorna false)
    // senão pode mostrar retorna true
    if(this.alunosProcessoFinalizadoEPagoOuPendente?.length > 0){
      return !this.alunosProcessoFinalizadoEPagoOuPendente.some((pm: any) => pm.alunoId === alunoId);
    } else {
      return true;
    }
  }
}
